window.palletPhotoLists = {
  "best-buy-electronics-16-free-shipping-eligible": {
    "title": "Best Buy Electronics #16 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-16-free-shipping-eligible-best-buy-electronics-16-free-shipping-eligible-liquidationdeals-ca-1256995193.jpg?v=1788467439",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Midea 3-in-1 portable air-conditioner boxes",
        "price": "329.00",
        "url": "https://www.walmart.ca/en/ip/Midea-12000-BTU-ASHRAE-8000-BTU-SACC-SmartCool-Portable-Air-Conditioner/6000208477352",
        "note": "Comparable Midea 12,000 BTU / 8,000 SACC model. Exact model/accessories unconfirmed; reference listing out of stock."
      },
      {
        "label": "Arctic King appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-15-free-shipping-eligible": {
    "title": "Best Buy Electronics #15 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-15-free-shipping-eligible-best-buy-electronics-15-free-shipping-eligible-liquidationdeals-ca-1256995185.jpg?v=1788467677",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Midea portable air-conditioner boxes",
        "price": "329.00",
        "url": "https://www.walmart.ca/en/ip/Midea-12000-BTU-ASHRAE-8000-BTU-SACC-SmartCool-Portable-Air-Conditioner/6000208477352",
        "note": "Comparable Midea 12,000 BTU / 8,000 SACC model. Exact model/accessories unconfirmed; reference listing out of stock."
      },
      {
        "label": "Hamilton Beach microwave box",
        "price": "99.98",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-1-1-Cu-ft-1000W-Countertop-Microwave-with-Child-Safety-Lock/6000207490445",
        "note": "Comparable Hamilton Beach 1.1 cu. ft. microwave. Exact capacity/model unconfirmed."
      },
      {
        "label": "A1 water-cooler box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-17-free-shipping-eligible": {
    "title": "Best Buy Electronics #17 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-17-free-shipping-eligible-best-buy-electronics-17-free-shipping-eligible-liquidationdeals-ca-1256995204.jpg?v=1788467796",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Hamilton Beach microwave boxes",
        "price": "99.98",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-1-1-Cu-ft-1000W-Countertop-Microwave-with-Child-Safety-Lock/6000207490445",
        "note": "Comparable Hamilton Beach 1.1 cu. ft. microwave. Exact capacity/model unconfirmed."
      },
      {
        "label": "Midea 5,000 BTU room air-conditioner box",
        "price": "140.00",
        "url": "https://www.walmart.ca/en/ip/Midea-5-000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "note": "Comparable Midea 5,000 BTU window unit. Exact model/accessories unconfirmed."
      },
      {
        "label": "Greenworks 2,000 PSI pressure-washer boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Arctic King appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-18-free-shipping-eligible": {
    "title": "Best Buy Electronics #18 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-18-free-shipping-eligible-best-buy-electronics-18-free-shipping-eligible-liquidationdeals-ca-1256995207.jpg?v=1788467917",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Hamilton Beach microwave box",
        "price": "99.98",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-1-1-Cu-ft-1000W-Countertop-Microwave-with-Child-Safety-Lock/6000207490445",
        "note": "Comparable Hamilton Beach 1.1 cu. ft. microwave. Exact capacity/model unconfirmed."
      },
      {
        "label": "LG microwave box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Snow Joe snow-tool box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Compact refrigerator",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-20-free-shipping-eligible": {
    "title": "Best Buy Electronics #20 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-20-free-shipping-eligible-best-buy-electronics-20-free-shipping-eligible-liquidationdeals-ca-1256995225.jpg?v=1788468279",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Midea room air-conditioner boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Frigidaire compact refrigerator box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Hamilton Beach dehumidifier box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-04-free-shipping-eligible": {
    "title": "Best Buy Electronics #04 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-04-free-shipping-eligible-best-buy-electronics-04-free-shipping-eligible-liquidationdeals-ca-1256995218.jpg?v=1788468397",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Bissell PowerForce vacuum-cleaner boxes",
        "price": "84.98",
        "url": "https://www.walmart.ca/en/ip/BISSELL-PowerForce-Bagless-Upright-Vacuum/6000206717586",
        "note": "Comparable Bissell PowerForce upright vacuum. Exact model unconfirmed."
      },
      {
        "label": "Two-door refrigerator box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-21-free-shipping-eligible": {
    "title": "Best Buy Electronics #21 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-21-free-shipping-eligible-best-buy-electronics-21-free-shipping-eligible-liquidationdeals-ca-1256995177.jpg?v=1788468517",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Midea room air-conditioner boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-22-free-shipping-eligible": {
    "title": "Best Buy Electronics #22 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-22-free-shipping-eligible-best-buy-electronics-22-free-shipping-eligible-liquidationdeals-ca-1256995228.jpg?v=1788468636",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Midea portable air-conditioner boxes",
        "price": "329.00",
        "url": "https://www.walmart.ca/en/ip/Midea-12000-BTU-ASHRAE-8000-BTU-SACC-SmartCool-Portable-Air-Conditioner/6000208477352",
        "note": "Comparable Midea 12,000 BTU / 8,000 SACC model. Exact model/accessories unconfirmed; reference listing out of stock."
      },
      {
        "label": "Frigidaire compact refrigerator box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-23-free-shipping-eligible": {
    "title": "Best Buy Electronics #23 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-23-free-shipping-eligible-best-buy-electronics-23-free-shipping-eligible-liquidationdeals-ca-1256995181.jpg?v=1788468758",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Hamilton Beach microwave boxes",
        "price": "99.98",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-1-1-Cu-ft-1000W-Countertop-Microwave-with-Child-Safety-Lock/6000207490445",
        "note": "Comparable Hamilton Beach 1.1 cu. ft. microwave. Exact capacity/model unconfirmed."
      },
      {
        "label": "Panasonic microwave boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Midea appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "best-buy-electronics-24-free-shipping-eligible": {
    "title": "Best Buy Electronics #24 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-24-free-shipping-eligible-best-buy-electronics-24-free-shipping-eligible-liquidationdeals-ca-1256995232.jpg?v=1788468877",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Midea portable air-conditioner boxes",
        "price": "329.00",
        "url": "https://www.walmart.ca/en/ip/Midea-12000-BTU-ASHRAE-8000-BTU-SACC-SmartCool-Portable-Air-Conditioner/6000208477352",
        "note": "Comparable Midea 12,000 BTU / 8,000 SACC model. Exact model/accessories unconfirmed; reference listing out of stock."
      },
      {
        "label": "Hamilton Beach appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-190": {
    "title": "Bulk Electronics #188 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-188-free-shipping-eligible-bulk-electronics-188-free-shipping-eligible-liquidationdeals-ca-1256833059.jpg?v=1788381069",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Countertop dishwasher box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Vibration plate box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Space-heater box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Packaged lighting fixtures",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-189": {
    "title": "Bulk Electronics #189 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-189-free-shipping-eligible-bulk-electronics-189-free-shipping-eligible-liquidationdeals-ca-1256833058.jpg?v=1788381096",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Drywall sander box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Electric griddle box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "FOTING pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Vibration plate box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-186": {
    "title": "Bulk Electronics #185 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-185-bulk-electronics-185-liquidationdeals-ca-1256791588.png?v=1788359377",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "KitchenAid mixer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Herdio ceiling-speaker box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Gawfolk monitor box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Vacuum-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-184": {
    "title": "Bulk Electronics #184 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-184-bulk-electronics-184-liquidationdeals-ca-1256791589.png?v=1788359412",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Racing wheel and pedals box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Food dehydrator box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "MALYAN-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a pressure washer",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-178": {
    "title": "Bulk Electronics #178 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-178-bulk-electronics-178-liquidationdeals-ca-1256791595.png?v=1788359591",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Dehumidifier box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Cuisinart stand-mixer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "BENGOO gaming-headset box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Elliptical trainer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Rockville audio-equipment box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-175": {
    "title": "Bulk Electronics #175 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-175-bulk-electronics-175-liquidationdeals-ca-1256791597.png?v=1788359650",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Towel-warmer cabinet box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Electric garage-heater box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "FOTING pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Grandfalls retractable-hose pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-174": {
    "title": "Bulk Electronics #174 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-174-bulk-electronics-174-liquidationdeals-ca-1256791598.png?v=1788359678",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Tineco floor-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Rice Robot rice-cooker box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "WEIMAX standing-fan box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "ZIPEAK ceiling-heater box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Countertop cooking-appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-171": {
    "title": "Bulk Electronics #171 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-171-bulk-electronics-171-liquidationdeals-ca-1256791601.png?v=1788359796",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Racing wheel and pedals box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Biltchway pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Cordless floor-scrubber box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "AIVOLT pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-177": {
    "title": "Bulk Electronics #177 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-177-bulk-electronics-177-liquidationdeals-ca-1256791604.png?v=1788359888",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "JIMMY cleaning-appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Scanner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "BOSWELL air-fryer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "FOTING pressure-washer boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Steam-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Headphone box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-185": {
    "title": "Bulk Electronics #185 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-185-bulk-electronics-185-liquidationdeals-ca-1256791605.jpg?v=1788359916",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "KitchenAid mixer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Herdio ceiling-speaker box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Gawfolk monitor box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Vacuum-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-17-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #17-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-17-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-17-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549553.png?v=1788208176",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Anker-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "PROMOUNT-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-01-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #01-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-01-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-01-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549554.png?v=1788208209",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "GAMING HEADSET-labelled box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-02-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #02-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-02-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-02-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549555.png?v=1788208237",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a small white heater",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-16-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #16-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-16-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-16-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572537.png?v=1788215377",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Honeywell-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a two-burner hot plate",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-14-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #14-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-14-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-14-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572539.png?v=1788215437",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a portable speaker",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a small desk fan",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-07-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #07-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-07-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-07-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549551.png?v=1788208331",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "HUMIDIFIER-labelled box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-09-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #09-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-09-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-09-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549549.png?v=1788208359",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Thermal-printer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "SLOOSH-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-10-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #10-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-10-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-10-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549548.png?v=1788208391",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "UGREEN-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Toy activity-set box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-12-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #12-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-12-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-12-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572541.png?v=1788215497",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a flat rectangular electronic device",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-08-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #08-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-08-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-08-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549550.png?v=1788208418",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a hair-styling tool",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "MAXLIN-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "ASTON-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-13-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #13-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-13-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-13-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572540.png?v=1788215528",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "SHALL tool-set box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "moman-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #16 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-16-wholesale-liquidation-pallet-high-count-fc-16-wholesale-liquidation-pallet-liquidationdeals-ca-1255914757.jpg?v=1787783380",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-174": {
    "title": "Medium General Merchandise 167",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-167-medium-general-merchandise-167-liquidationdeals-ca-1255898179.jpg?v=1787776273",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Gourmia air-fryer box",
        "price": "89.98",
        "url": "https://www.walmart.ca/en/ip/Gourmia-5-7-L-6-QT-Digital-Air-Fryer-GAF616/6000207744567",
        "note": "Comparable Gourmia 6-quart GAF616 air fryer. Exact capacity/model unconfirmed."
      },
      {
        "label": "Roomba robot-vacuum box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "ILM-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "FALKAR-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-173": {
    "title": "Medium General Merchandise 170",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-170-medium-general-merchandise-170-liquidationdeals-ca-1255898180.jpg?v=1787776298",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Patio-product box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Residential RV toilet box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-171": {
    "title": "Medium General Merchandise 171",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-171-medium-general-merchandise-171-liquidationdeals-ca-1255898181.jpg?v=1787776329",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Truck floor-protection box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "R8 garage-door insulation boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Miter-saw box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-177": {
    "title": "Medium General Merchandise 177",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-177-medium-general-merchandise-177-liquidationdeals-ca-1255898182.jpg?v=1787776359",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Inflatable play-centre box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Freein-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "KENIMOTO-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-176": {
    "title": "Medium General Merchandise 176",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-176-medium-general-merchandise-176-liquidationdeals-ca-1255898184.jpg?v=1787776417",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Toddler activity-toy boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Portable greenhouse box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Lunix-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-162": {
    "title": "Medium General Merchandise 162",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-162-medium-general-merchandise-162-liquidationdeals-ca-1255898187.jpg?v=1787776450",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a wheeled office chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "LAEOTI-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-169": {
    "title": "Medium General Merchandise 169",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-169-medium-general-merchandise-169-liquidationdeals-ca-1255898189.jpg?v=1787776478",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Control-arm kit box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folding rocking-chair box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "YOUNUO-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-159": {
    "title": "Medium General Merchandise 159",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-159-medium-general-merchandise-159-liquidationdeals-ca-1255898185.jpg?v=1787776511",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "K&N air-intake system box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "GOTIDY-branded cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Brother printer-consumable box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a cylindrical bin",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-163": {
    "title": "Medium General Merchandise 163",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-163-medium-general-merchandise-163-liquidationdeals-ca-1255898192.jpg?v=1787776597",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Folding camping-chair box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a multi-drawer unit",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-164": {
    "title": "Medium General Merchandise 164",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-164-medium-general-merchandise-164-liquidationdeals-ca-1255898188.jpg?v=1787776691",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Toshiba-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a wheeled stool",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-170": {
    "title": "Medium General Merchandise 170",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-170-medium-general-merchandise-170-liquidationdeals-ca-1255898186.jpg?v=1787776720",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Patio-product box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Residential RV toilet box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-167": {
    "title": "Medium General Merchandise 167",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-167-medium-general-merchandise-167-liquidationdeals-ca-1255898195.jpg?v=1787776748",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Playpen box labelled 150 × 180",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Chefman-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-135-1": {
    "title": "Medium General Merchandise #135-1",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-135-1-medium-general-merchandise-135-1-liquidationdeals-ca-1255797474.jpg?v=1787689775",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "iFold-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "CHAMPRO-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-139": {
    "title": "Medium General Merchandise #139 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-139-medium-general-merchandise-139-liquidationdeals-ca-1255797477.jpg?v=1787689870",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "VEVOR-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Christmas-decoration box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-144": {
    "title": "Medium General Merchandise #144",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-144-medium-general-merchandise-144-liquidationdeals-ca-1255797478.jpg?v=1787689898",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Evenflo-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "BLACK / WHITE-labelled carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-145": {
    "title": "Medium General Merchandise #145",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-145-medium-general-merchandise-145-liquidationdeals-ca-1255797479.jpg?v=1787689930",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Home steam-sauna box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Gardner Pet-branded cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Tent-frame box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-147": {
    "title": "Medium General Merchandise #147",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-147-medium-general-merchandise-147-liquidationdeals-ca-1255797480.jpg?v=1787689957",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Rotating dumbbell-set box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a bench",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-138": {
    "title": "Medium General Merchandise #138 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-138-medium-general-merchandise-138-liquidationdeals-ca-1255797482.jpg?v=1787690016",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Helavo H1070 rollator box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Globber scooter box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Control-arm kit box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-148": {
    "title": "Medium General Merchandise #148",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-148-medium-general-merchandise-148-liquidationdeals-ca-1255797485.jpg?v=1787690112",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Barstool box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "CHERRYLUX floor-mattress box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Gardner Pet-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "VEVOR-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-143-1-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #143-1 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-143-1-liquidation-pallet-wholesale-medium-general-merchandise-143-1-liquidation-pallet-wholesale-liquidationdeals-ca-1255797486.jpg?v=1787690139",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Water-table box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "okaysou-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-157-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #157 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-157-liquidation-pallet-wholesale-medium-general-merchandise-157-liquidation-pallet-wholesale-liquidationdeals-ca-1255797487.jpg?v=1787690169",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a wheeled office chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-156-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #156 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-156-liquidation-pallet-wholesale-medium-general-merchandise-156-liquidation-pallet-wholesale-liquidationdeals-ca-1255797488.jpg?v=1787690196",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "COSCO-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-155-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #155 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-155-liquidation-pallet-wholesale-medium-general-merchandise-155-liquidation-pallet-wholesale-liquidationdeals-ca-1255797489.jpg?v=1787690230",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Carex raised toilet-seat box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Raised toilet-seat box with handles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Telescopic-gate carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-154-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #154 — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-154-liquidation-pallet-wholesale-medium-general-merchandise-154-liquidation-pallet-wholesale-liquidationdeals-ca-1255797490.jpg?v=1787690257",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Memory-foam mattress-topper box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Water-table box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "GOTIDY-branded cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-151-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #151 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-151-liquidation-pallet-wholesale-medium-general-merchandise-151-liquidation-pallet-wholesale-liquidationdeals-ca-1255797493.jpg?v=1787690348",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Helavo rollator box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Infrared sensor trash-can box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Carex-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-150-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #150 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-150-liquidation-pallet-wholesale-medium-general-merchandise-150-liquidation-pallet-wholesale-liquidationdeals-ca-1255797494.jpg?v=1787690376",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Body-wedge cushion package",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Garage floor-mat box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "CHERRYLUX floor-mattress box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "REALEAD artificial-tree box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-42-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #42 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-42-liquidation-pallet-wholesale-medium-general-merchandise-42-liquidation-pallet-wholesale-liquidationdeals-ca-1255270428.jpg?v=1787250577",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Folding camping-chair box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-41-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #41 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-41-liquidation-pallet-wholesale-medium-general-merchandise-41-liquidation-pallet-wholesale-liquidationdeals-ca-1255270429.jpg?v=1787250609",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Narrow bookshelf box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Portable gazebo / tent carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-40-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #40 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-40-liquidation-pallet-wholesale-medium-general-merchandise-40-liquidation-pallet-wholesale-liquidationdeals-ca-1255270430.jpg?v=1787250638",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Liberty Garden-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing an office chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "VEVOR-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-36-liquidation-pallet-wholesale-copy-1": {
    "title": "Medium General Merchandise #37 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-37-liquidation-pallet-wholesale-medium-general-merchandise-37-liquidation-pallet-wholesale-liquidationdeals-ca-1255270433.jpg?v=1787250731",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Raised toilet-seat box with handles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wall-mirror carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a wheeled chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-35-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #35 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-35-liquidation-pallet-wholesale-medium-general-merchandise-35-liquidation-pallet-wholesale-liquidationdeals-ca-1255270434.jpg?v=1787250757",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Air-cooler boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "10-foot offset hanging-umbrella box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Pop-up sun-shelter carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-33-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #33 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-33-liquidation-pallet-wholesale-medium-general-merchandise-33-liquidation-pallet-wholesale-liquidationdeals-ca-1255270436.jpg?v=1787250817",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Ultrathin body-slimmer carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "safe-box-electronics-pallet-120-liquidation-pallet-wholesale-copy": {
    "title": "Overstock Safe Box Electronics Pallet #116 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-safe-box-electronics-pallet-116-liquidation-pallet-wholesale-overstock-safe-box-electronics-pallet-116-liquidation-pallet-wholesale-liquidationdeals-ca-1255270440.jpg?v=1787250936",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Boxes showing keypad safes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "safe-box-electronics-pallet-liquidation-pallet-wholesale-copy": {
    "title": "Overstock Safe Box Electronics Pallet #119 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-safe-box-electronics-pallet-119-liquidation-pallet-wholesale-overstock-safe-box-electronics-pallet-119-liquidation-pallet-wholesale-liquidationdeals-ca-1255270442.jpg?v=1787250996",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Boxes showing keypad safes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-28-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #27 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-27-liquidation-pallet-wholesale-medium-general-merchandise-27-liquidation-pallet-wholesale-liquidationdeals-ca-1255051999.jpg?v=1787171711",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a wheeled office chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-electronics-113-liquidation-pallet-wholesale-copy": {
    "title": "Medium Electronics #113 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-113-liquidation-pallet-wholesale-medium-electronics-113-liquidation-pallet-wholesale-liquidationdeals-ca-1255052005.jpg?v=1787171891",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Proctor Silex-branded appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a portable cooling appliance",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-electronics-29-liquidation-pallet-wholesale-copy": {
    "title": "Medium Electronics #24 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-24-liquidation-pallet-wholesale-medium-electronics-24-liquidation-pallet-wholesale-liquidationdeals-ca-1255043577.jpg?v=1787164330",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Racing wheel and pedals box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Herdio outdoor-speaker box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Toshiba microwave box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "hermitlux countertop-appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Range-hood box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale-copy-8": {
    "title": "Medium Electronics #29 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-29-liquidation-pallet-wholesale-medium-electronics-29-liquidation-pallet-wholesale-liquidationdeals-ca-1255043578.jpg?v=1787164358",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Cordless pole-saw box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Aquastrong pump box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wall-pack light box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Grandfalls pressure-washer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-electronics-111-liquidation-pallet-wholesale-copy-1": {
    "title": "Medium Electronics #105 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-105-liquidation-pallet-wholesale-medium-electronics-105-liquidation-pallet-wholesale-liquidationdeals-ca-1255043579.jpg?v=1787164389",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "iNOVIVA Slushie frozen-drink maker box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "momcozy appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Air-cooler box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Steam-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "ARMSEN countertop-dishwasher box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale-copy-6": {
    "title": "Medium Electronics #109 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-109-liquidation-pallet-wholesale-medium-electronics-109-liquidation-pallet-wholesale-liquidationdeals-ca-1255043582.jpg?v=1787164481",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Waterdrop countertop water-dispenser box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Ice-crusher box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Electric-griddle box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Oscillating tower-fan box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "ARMSEN countertop-dishwasher box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale-copy-5": {
    "title": "Medium Electronics #108 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-108-liquidation-pallet-wholesale-medium-electronics-108-liquidation-pallet-wholesale-liquidationdeals-ca-1255043583.jpg?v=1787164511",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "ZIPEAK patio-heater box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Air-cooler box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Keenray towel-warmer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Vibration plate box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Smart cat litter-box carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-147-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #147 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-147-liquidation-pallet-wholesale-medium-general-merchandise-147-liquidation-pallet-wholesale-liquidationdeals-ca-1255043593.jpg?v=1787164812",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing an office chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-145-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #145 | Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-145-liquidation-pallet-wholesale-medium-general-merchandise-145-liquidation-pallet-wholesale-liquidationdeals-ca-1255043595.jpg?v=1787164873",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Gardner Pet-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-24-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #24 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913090.jpg?v=1786487469",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-23-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #23 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-23-liquidation-wholesale-pallet-overstock-infant-socks-23-liquidation-wholesale-pallet-liquidationdeals-ca-1253913093.jpg?v=1786487558",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-22-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #22 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-22-liquidation-wholesale-pallet-overstock-infant-socks-22-liquidation-wholesale-pallet-liquidationdeals-ca-1253913096.jpg?v=1786487648",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-21-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #21 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-21-liquidation-wholesale-pallet-overstock-infant-socks-21-liquidation-wholesale-pallet-liquidationdeals-ca-1253913099.jpg?v=1786487738",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-20-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #20 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-20-liquidation-wholesale-pallet-overstock-infant-socks-20-liquidation-wholesale-pallet-liquidationdeals-ca-1253913102.jpg?v=1786487829",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-17-liquidation-wholesale-pallet-copy-1": {
    "title": "Overstock Infant Socks #18 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-18-liquidation-wholesale-pallet-overstock-infant-socks-18-liquidation-wholesale-pallet-liquidationdeals-ca-1253913106.jpg?v=1786487948",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-17-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #17 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-17-liquidation-wholesale-pallet-overstock-infant-socks-17-liquidation-wholesale-pallet-liquidationdeals-ca-1253913110.jpg?v=1786488068",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-16-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #16 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-16-liquidation-wholesale-pallet-overstock-infant-socks-16-liquidation-wholesale-pallet-liquidationdeals-ca-1253913113.jpg?v=1786488157",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-14-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #15 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-15-liquidation-wholesale-pallet-overstock-infant-socks-15-liquidation-wholesale-pallet-liquidationdeals-ca-1253913116.jpg?v=1786488248",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-miscellaneous-14-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #14 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-14-liquidation-wholesale-pallet-overstock-infant-socks-14-liquidation-wholesale-pallet-liquidationdeals-ca-1253913121.jpg?v=1786488335",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-mixed-electronics-13-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Miscellaneous #13 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-miscellaneous-13-liquidation-wholesale-pallet-overstock-miscellaneous-13-liquidation-wholesale-pallet-liquidationdeals-ca-1253913125.jpg?v=1786488455",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed flat shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-mixed-electronics-12-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #12 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-12-liquidation-wholesale-pallet-overstock-mixed-electronics-12-liquidation-wholesale-pallet-liquidationdeals-ca-1253913128.jpg?v=1786488548",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Aipsun lighting box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Closed flat shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-mixed-electronics-11-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #11 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-11-liquidation-wholesale-pallet-overstock-mixed-electronics-11-liquidation-wholesale-pallet-liquidationdeals-ca-1253913132.jpg?v=1786488638",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Curtain-rod carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Closed flat shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "amz-clothing-03-1000pcs-liquidation-wholesale-pallet-copy": {
    "title": "Amz Clothing #03 - 1000pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/amz-clothing-03-1000pcs-liquidation-wholesale-pallet-amz-clothing-03-1000pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1253592822.jpg?v=1786141838",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Open gaylord with wrapped contents; individual garments not distinguishable",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-mixed-electronics-10-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #10 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-10-liquidation-wholesale-pallet-overstock-mixed-electronics-10-liquidation-wholesale-pallet-liquidationdeals-ca-1253592854.jpg?v=1786142677",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed shipping cartons; item labels not readable",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-bath-body-works-fragrance-refills-8-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #9 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-9-liquidation-wholesale-pallet-overstock-mixed-electronics-9-liquidation-wholesale-pallet-liquidationdeals-ca-1253592857.jpg?v=1786142771",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed shipping cartons; item labels not readable",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-sauna-blankets-7-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Grow Bags #7 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-grow-bags-7-liquidation-wholesale-pallet-overstock-grow-bags-7-liquidation-wholesale-pallet-liquidationdeals-ca-1253585568.jpg?v=1786134791",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Black fabric grow bags",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Packaged soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-gloves-6-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Sauna Blankets #6 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-sauna-blankets-6-liquidation-wholesale-pallet-overstock-sauna-blankets-6-liquidation-wholesale-pallet-liquidationdeals-ca-1253585559.jpg?v=1786134877",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Folded sauna blanket",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-gloves-3-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Pillow Cases #3 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-pillow-cases-3-liquidation-wholesale-pallet-overstock-pillow-cases-3-liquidation-wholesale-pallet-liquidationdeals-ca-1253585551.jpg?v=1786135238",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Orange textured pillow covers",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Closed small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-infant-socks-1-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #1 | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585579.jpg?v=1786135478",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed cartons beside an infant-socks pallet label",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-01-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #01 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-01-wholesale-liquidation-pallet-high-count-fc-01-wholesale-liquidation-pallet-liquidationdeals-ca-1253144487.jpg?v=1785976598",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed gaylord; individual items not visible",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-30-liquidation-pallet-wholesale-copy": {
    "title": "Highcount LPN Pallet #30 — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-30-liquidation-pallet-wholesale-highcount-lpn-pallet-30-liquidation-pallet-wholesale-liquidationdeals-ca-1249110924.jpg?v=1784061519",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed gaylord; individual items not visible",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-66-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #66 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-66-wholesale-liquidation-pallet-high-count-fc-66-wholesale-liquidation-pallet-liquidationdeals-ca-1244089495.jpg?v=1781303498",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Packaged textiles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-63-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #63 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-63-wholesale-liquidation-pallet-high-count-fc-63-wholesale-liquidation-pallet-liquidationdeals-ca-1244089501.jpg?v=1781303677",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Packaged textiles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-61-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #61 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-61-wholesale-liquidation-pallet-high-count-fc-61-wholesale-liquidation-pallet-liquidationdeals-ca-1244089505.jpg?v=1781303797",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Packaged textiles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-26-900pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #26- 300pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-26-300pcs-liquidation-wholesale-pallet-miscellaneous-clothing-26-300pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243970491.jpg?v=1781202636",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Denim jeans",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Graphic T-shirts",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Striped tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-25-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #25- 900pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-25-900pcs-liquidation-wholesale-pallet-miscellaneous-clothing-25-900pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243970493.jpg?v=1781202697",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Graphic T-shirts",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-24-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #24- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-24-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-24-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800639.jpg?v=1781195439",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Striped tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded light-coloured garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded trousers",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #23- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800640.jpg?v=1781195499",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Printed tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded dark garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-22-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #22- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-22-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-22-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800635.jpg?v=1781116240",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Printed and striped tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet": {
    "title": "Miscellaneous Clothing #21- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-21-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-21-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800637.jpg?v=1781116297",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Graphic T-shirts",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-39-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #40 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-40-wholesale-liquidation-pallet-high-count-fc-40-wholesale-liquidation-pallet-liquidationdeals-ca-1238248569.jpg?v=1778697335",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Wrapped soft goods at the top of the gaylord",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-christmas-tree-pallet-liquidation-wholesale-pallet": {
    "title": "Overstock Christmas Tree Pallet | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-christmas-tree-pallet-liquidation-wholesale-pallet-overstock-christmas-tree-pallet-liquidation-wholesale-pallet-liquidationdeals-ca-1210916311.jpg?v=1765478089",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Pre-lit flocked artificial-tree boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Slim artificial-tree box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Packaged Christmas decorations",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  }
};

